import React from 'react';
import {useSelector} from 'react-redux';
import {getUserDetails} from '../../shared/utils';

import classes from './PartnerBadge.module.scss';
import clsx from 'clsx';
import {startCase} from 'lodash';

export default ( { showIcon = true, level } ) => {
    const user = useSelector(state => state.auth.user);
    const badgeLevel = level || (user ? getUserDetails(user).level : null);

    let levelBadge;
    if (badgeLevel) {
        const imgSrc = require(`../../assets/images/partner-badge/partner-badge-${badgeLevel.toLowerCase()}-small.png`);
        levelBadge = <img src={imgSrc} alt={`Partner level ${badgeLevel} icon`}/>
    }
    else {
        levelBadge = 'Loading...';
    }

    return <div className={clsx(classes.PartnerBadge, badgeLevel && classes[startCase(badgeLevel.toLowerCase())])}>
        {badgeLevel}{showIcon && levelBadge}
    </div>;
};
